import { LocaleSync } from '@saniplus/api-client';
import { SessionGate } from '@saniplus/ui';
import { RouterProvider } from 'react-router/dom';

import { router } from './app/router';

import { SplashScreen } from './components/SplashScreen';

/**
 * `SessionGate` sits outside the router on purpose: it runs
 * `bootstrapSession` once and holds the tree until the refresh round trip has
 * settled. Inside the router, every guard would decide "anonymous" first and
 * bounce a signed-in user to `/login` on every reload.
 */
export function App() {
  return (
    <SessionGate fallback={<SplashScreen />}>
      <LocaleSync />
      <RouterProvider router={router} />
    </SessionGate>
  );
}
